var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68265 6.84893C5.32202 8.54238 3.98665 10.1702 2.65518 11.8086L2.82234 12.0076L7.74977 7.51361C9.20954 9.04407 10.714 9.09064 12.1796 7.51361L17.1051 12.0055L17.2703 11.8107L13.2331 6.83623C15.4335 5.31424 17.4938 3.60809 19.6981 2.12421L19.84 2.27027V2.84604C19.84 6.15109 19.84 9.45544 19.84 12.7591C19.84 13.7582 19.4026 14.2408 18.4793 14.2408C12.8061 14.2408 7.13166 14.2408 1.45588 14.2408C0.468446 14.2387 0 13.7286 0 12.6659C0 9.38064 0 6.09535 0 2.81005C0.0183999 2.62348 0.0528919 2.43921 0.103019 2.25968C0.289934 2.28249 0.472332 2.3375 0.643385 2.42268C2.63963 3.87269 4.62615 5.33541 6.68265 6.84893Z",
    fill: "#B22134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0143 0.964237H18.7457C18.9077 0.948162 19.071 0.954564 19.2316 0.983288C19.3735 1.02139 19.5951 1.12511 19.6067 1.22249C19.6076 1.41126 19.5431 1.59345 19.426 1.73263C19.2798 1.87839 19.1131 1.99773 18.9323 2.08614C16.3509 3.61305 13.769 5.13926 11.1864 6.66476C10.8196 6.90069 10.4014 7.02515 9.97539 7.02515C9.5494 7.02515 9.13121 6.90069 8.76442 6.66476C6.15459 5.12232 3.54217 3.57495 0.927162 2.02263C0.777658 1.95824 0.64004 1.86503 0.520915 1.74745C0.459381 1.68265 0.410458 1.60503 0.377063 1.5192C0.343668 1.43337 0.326485 1.3411 0.326538 1.24789C0.355695 1.12511 0.581171 1.03621 0.736673 0.979055C0.899232 0.949969 1.06466 0.944985 1.22845 0.964237H10.0143Z",
    fill: "#B22134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRed);
export default __webpack_public_path__ + "static/media/Mail-red.584d7d72f6404bbe06998e266b81dcaf.svg";
export { ForwardRef as ReactComponent };